/**
 * The coefficient that determines the width/height ratio for the
 * standard 16:9 aspect ratio. It's basically Math.round(16/9).
 */
const ASPECT_RATIO_COEFFICIENT = 1.78;

/**
 * Returns a height that matches an aspect ratio of 16:9.
 * The formula is width/16/9 or width / 1.78.
 */
export const getAspectRatioHeight = (width: number) =>
  Math.round(width / ASPECT_RATIO_COEFFICIENT);

export const isAudio = (fileType: string) => fileType.includes('audio');

export const isVideo = (fileType: string) => fileType.includes('video');
